var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background fade-in-bg"},[_c('transition',{attrs:{"name":"fade-bg"}},[_c('div',{staticClass:"intro full-image"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }